<template>
  <div class="wrapper tw-overflow-hidden">
    <Rewind :isPreview="true" :trip="trip" :route="route" @ready="showOverlay = true"></Rewind>

    <div :class="['button-wrapper', showOverlay ? 'visible' : '']">
      <div class="relative-wrapper">
        <IconsProBadge v-if="!authStore.isUserPro" class="pro-icon tw-w-4" />

        <button
          @click="openRewind"
          style="font-size: 16px"
          class="center-absolute button white-button fullwidth-button"
        >
          {{ $t('reWind') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  trip: Object,
  route: Object
})

const authStore = useAuthStore()

const { requirePro } = useProGate()

const showOverlay = ref(false)

const openRewind = () => {
  requirePro('rewind', () => {
    window.open('/t/' + props.trip.rewind_token + '/rewind')
  })
}
</script>

<style lang="sass" scoped>
@import "@/assets/vars.sass" // SASS variables

.wrapper
    height: 300px
    position: relative
    border-radius: $border-radius

:deep(.hint)
    display: none
:deep(.maplibregl-ctrl-bottom-right)
    display: none!important
:deep(.maplibregl-ctrl-bottom-left)
    display: none!important

.button-wrapper
    opacity: 0
    background-color: rgba(0,0,0, 0.4)
    width: 100%
    height: 100%
    position: absolute
    display: flex
    align-items: center
    justify-content: center
    transition: opacity .5s ease
    top: 0
    left: 0
    &.visible
        opacity: 1

.relative-wrapper
    position: relative
.pro-icon
    position: absolute
    top: 0px
    right: 0px
    transform: translate(50%, -50%)
</style>
